//---------------------------------------------------------------------------------------------------
// ## IMPORTS ##
// Library Imports
import { useEffect, useState } from "react";

// Custom components imports (and hooks and helpers)
import { useAppDispatch, useAppSelector } from "../../store/hooks";

import { Grid, Typography, useTheme } from "@mui/material";

import { Params, useNavigate, useParams } from "react-router-dom";
import { useCreateSceneMutation, useGetScenesQuery } from "../../services/scene.service";
import { EDraggableOptions } from "@virtus-tech-repository/virtus-tech-repository/lib/models/media.model";
import { IScene } from "@virtus-tech-repository/virtus-tech-repository/lib/models/scenario.model";

import { VTButton, VTTypography } from "@virtus-tech-repository/virtus-tech-repository";

import { LineChart, PieChart } from "@mui/x-charts";
import { ITrackingActions } from "../../models/tracking.models";
import VTOverviewUser from "../components/OverviewUser";
import NoUser from "../../assets/images/NoScenarios.svg";
import { setCurrentSidePanel } from "../../store/slices/current.slice";

interface IProps {
    drawWidth: number;
}
//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// Error Page, to display on breaking errors and allows home navigation
export default function VTOverviewContainer({ drawWidth }: IProps) {
    //-------------------------------------------------------------------------------------------------
    // ## USE SELECTOR ##
    const theme = useTheme();
    const { currentSidePanel, selectedAttempt, currentSidePannelDesiredWidth, selectedVersion } = useAppSelector(
        (state) => state.currentReducer,
    );
    //-------------------------------------------------------------------------------------------------
    // ## USE STATE ##

    //-------------------------------------------------------------------------------------------------
    // ## HOOKS ##
    const { scenarioId, sceneId }: Readonly<Params<string>> = useParams();

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { data: scenes } = useGetScenesQuery(selectedVersion ? selectedVersion : scenarioId ? scenarioId : "");

    //-------------------------------------------------------------------------------------------------
    // ## RETURN ##
    // Displays return button and error message
    return (
        <>
            {/*-----------------------------------------------------------------------------------------*/}
            {/* Main page content */}
            {scenes && (
                <Grid
                    sx={{
                        height: `calc(100vh - 70px - ${drawWidth}px)`,
                        zIndex: 100000,
                        overflowY: "scroll",
                        paddingTop: "30px",
                        paddingBottom: "30px",
                        backgroundColor: theme.palette.background.default,
                        paddingInline: "40px",
                    }}
                    container
                    alignContent={"flex-start"}
                    justifyContent={"center"}
                >
                    {selectedAttempt ? (
                        <VTOverviewUser drawWidth={drawWidth} />
                    ) : (
                        <Grid container sx={{ height: "100%" }} justifyContent={"center"} alignContent={"center"}>
                            <Grid item xs={12} container justifyContent={"center"}>
                                <VTTypography type={"Heading2"} sx={{ marginBottom: "30px" }}>
                                    No user selected
                                </VTTypography>
                            </Grid>
                            <Grid item>
                                <img src={NoUser} />
                            </Grid>{" "}
                            <Grid item xs={12} container justifyContent={"center"}>
                                <VTTypography type={"Heading4"} sx={{ marginTop: "20px" }}>
                                    Please select a user from the side panel on the left
                                </VTTypography>
                            </Grid>
                            <Grid item xs={12} container justifyContent={"center"}>
                                <VTButton
                                    onClick={() => {
                                        dispatch(
                                            setCurrentSidePanel({
                                                currentTab: "Users",
                                                currentWidth: currentSidePannelDesiredWidth,
                                                option: undefined,
                                            }),
                                        );
                                    }}
                                >
                                    Choose user
                                </VTButton>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            )}
        </>
    );
}
